import React from 'react'
import { AiFillLinkedin } from 'react-icons/ai'
import { AiFillGithub } from 'react-icons/ai'
import { AiFillFacebook } from 'react-icons/ai'

function HeaderSocials() {
  return (
    <div className='header_socials'>
      <a href='https://linkdin.com' target='_blank'>
        <AiFillLinkedin></AiFillLinkedin>
      </a>
      <a href='https://github.com' target='_blank'>
        <AiFillGithub></AiFillGithub>
      </a>
      <a href='https://facebook.com' target='_blank'>
        <AiFillFacebook></AiFillFacebook>
      </a>
    </div>
  )
}

export default HeaderSocials
